export const stringToNullableNumber = function (val: string | undefined): number | null {
    if (typeof val === 'undefined') {
        return null;
    }
    const v = parseInt(val, 10);
    if (isNaN(v)) {
        return null;
    }

    return v;
};
